import { useEffect } from "react";
import Lenis from "lenis";
import { setLenis } from "../lib/site";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Microblading } from "../components/Microblading";
import { Nails } from "../components/Nails";
import { Gallery } from "../components/Gallery";
import { Contact } from "../components/Contact";
import { Location } from "../components/Location";
import { Footer } from "../components/Footer";
import { ChatWidget } from "../components/ChatWidget";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    setLenis(lenis);
    let id = requestAnimationFrame(function raf(t) { lenis.raf(t); id = requestAnimationFrame(raf); });
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  return (
    <main data-testid="home-page" className="overflow-x-clip">
      <Nav />
      <Hero />
      <Marquee />
      <Microblading />
      <Nails />
      <Gallery />
      <Contact />
      <Location />
      <Footer />
      <ChatWidget />
    </main>
  );
}
